import { useQueryClient } from '@tanstack/react-query';
import { useEffect, type ReactElement } from 'react';
import { useNavigate } from 'react-router';

import { registerSessionExpiredHandler } from '@features/auth';

export function SessionGuard(): ReactElement | null {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    registerSessionExpiredHandler(() => {
      queryClient.clear();
      void navigate('/login', { replace: true });
    });
  }, [navigate, queryClient]);

  return null;
}
